export default __webpack_public_path__ + "static/media/progress.e0d99148.png";